<template>
  <v-form lazy-validation @submit.prevent="next">
      <v-layout wrap row justify-center>
      <h3>&nbsp;</h3>
     </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm3>
        <v-radio-group v-model="v.type.$model">
          <v-radio color="primary" label="Solo informativo" value="A"/>
          <v-radio color="primary" label="Evento" value="E"/>
          <v-radio color="primary" label="Requerir confirmación" value="R"/>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 sm6 shrink>
        <v-expand-x-transition>
          <v-layout
            style="white-space: nowrap"
            row
            wrap
            justify-center
            v-show="v.type.$model == 'E'"
          >
            <v-flex xs12 sm6 class="text-xs-center">
              <v-checkbox
                label="Asistencia del tutor"
                color="primary"
                v-model="v.assistanceRequired.$model"
              />
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-center">
              <v-checkbox
                label="Confirmación del tutor"
                color="primary"
                v-model="v.confirmParent.$model"
              />
            </v-flex>
            <v-divider/>
            <v-flex xs12>
              <v-form>
                <v-layout wrap justify-space-around fill-height align-center>
                  <!-- <DateTimePicker
                    :errorMessages="dateStartErrors"
                    titleDate="Fecha de inicio"
                    titleTime="Hora de inicio"
                    v-model="v.startDate.$model"
                    :min="today"
                    :hour="hour"
                  /> -->
                  <VueTimePickerTool
                    :errorMessages="dateStartErrors"
                    titleDate="Fecha de inicio"
                    titleTime="Hora de inicio"
                    v-model="v.startDate.$model"
                    style="margin-top:20px;"
                    :min="today"
                    :hour="hour"
                  />
                </v-layout>
                <v-layout wrap justify-space-around fill-height align-center>
                  <!-- <DateTimePicker
                    :errorMessages="dateEndErrors"
                    titleDate="Fecha de término"
                    titleTime="Hora de término"
                    v-model="v.endDate.$model"
                    :min="today"
                  /> -->
                  <VueTimePickerTool
                    :errorMessages="dateEndErrors"
                    titleDate="Fecha de término"
                    titleTime="Hora de término"
                    location="up"
                    v-model="v.endDate.$model"
                    style="margin-top:20px;"
                    :min="today"
                  />
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-expand-x-transition>
      </v-flex>
      <v-flex xs12 sm3>
        <v-layout wrap row justify-center align-center fill-height>
          <v-fade-transition mode="out-in">
            <v-flex v-if="type == 'A'" xs6 key="A">
              <v-img :src="require('@/assets/notices/SKLB-Aviso 3.png')"/>
              <br >
              <p
                class="text-sm-center"
              >Notifica a los tutores de sucesos o acontecimientos importantes de tu institución.</p>
            </v-flex>
            <v-flex v-if="type == 'E'" xs6 key="E">
              <v-img :src="require('@/assets/notices/SKLB-Evento.png')"/>
              <br >
              <p
                class="text-sm-center"
              >Planea algún evento que se necesite de la presencia o autorización de los tutores.</p>
            </v-flex>
            <v-flex v-if="type == 'R'" xs6 key="R">
              <v-img :src="require('@/assets/notices/SKLB-informe.png')"/>
              <br >
              <p class="text-sm-center">Notifica a los tutores del avance académico de sus alumnos.</p>
            </v-flex>
          </v-fade-transition>
        </v-layout>
      </v-flex>
    </v-layout>
     <v-layout wrap row justify-center>
       <h3>&nbsp;</h3>
     </v-layout>
     <v-layout wrap row justify-center>
      <h3>&nbsp;</h3>
     </v-layout>
     <v-layout wrap row justify-center>
      <h3>&nbsp;</h3>
     </v-layout>
     <v-layout wrap row justify-center>
      <h3>&nbsp;</h3>
     </v-layout>
    <v-layout wrap row justify-center>
      <h3>&nbsp;</h3>
     </v-layout>
     <v-layout wrap row justify-center>
      <h3>&nbsp;</h3>
     </v-layout>
  </v-form>
</template>

<script>
import moment from "moment";
import DateTimePicker from "./Tools/DateTimePicker2";
import VueTimePickerTool from "../Notices/Tools/VueDateTimePicker";

import { required } from "vuelidate/lib/validators";
export default {
  props: ["value", "v"],
  components: {
    DateTimePicker,
    VueTimePickerTool

  },
  data: () => ({
    type: "A",
    today: "",
    hour:"",
    menu: {
      startD: false,
      startT: false,
      endD: false,
      endT: false
    },
    noticeForm: {}
  }),
  watch: {
    value() {
      this.type = this.value;
    }
  },
  mounted() {
    this.today = new Date().toLocaleDateString("sv-SE"); 
    this.hour = new Date().toLocaleTimeString("sv-SE",{hour: '2-digit', minute:'2-digit'});
    console.log(this.today + " " + this.hour)
  },
  computed: {
    dateStartErrors() {
      const errors = [];
      if (!this.v.startDate.$dirty) return errors;
      !this.v.startDate.required && errors.push("Fecha de inicio obligatoria");
      return errors;
    },
    dateEndErrors() {
      const errors = [];
      if (!this.v.endDate.$dirty) return errors;
      !this.v.endDate.validateDateEnd &&
        errors.push("La fecha final debe ser mayor a la de inicio");
      return errors;
    }
  }
};
</script>

<style>
</style>
